import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import Table from '../Table/Table';
import { Tables, Checkbox, Input, InputChange } from '@ixyberfree/ixybercomponents';
import './alarm.css';
import { event } from 'jquery';

interface IAlarm {
    visible?: boolean;
}

function ProcessAlarm(props: IAlarm) {
    const tabAlarmRef = useRef<HTMLDivElement>(null);
    //Данные для теста таблицы
    const [data, setData] = React.useState<any>([]);
    const VisibleDataRef = React.useRef();

    const buttonData = [
        { label: 'Print', id: 'menutopbutprint', className: 'button-style print' },
        {
            label: 'Acknowledge',
            id: 'menutopbutack',
            className: 'button-style ack',
            onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
                const source = event.ctrlKey
                    ? window.Base.Events.GetActiveEvents().CentumVP.AL.Messages
                    : VisibleDataRef.current;
                if (source) {
                    const ids = source
                        .filter((item: any) => ((item.NewState >> 2) & 1) === 1)
                        .map((item: any) => item.id);
                    if (ids.length) window.Base.Events.AckEvents(ids);
                }
            }
        },
        { label: 'High Priority', id: 'menutopbutunhigh', className: 'button-style high-priority' },
        { label: 'Current Volue', id: 'menutopbutcurrent', className: 'button-style current-value' },
        { label: 'Stop/Resume', id: 'menutopbutpause', className: 'button-style stop-resume' },
        { label: 'Filter', id: 'menutopbutfilter', className: 'button-style filter' },
        { label: 'Windows Setup', id: 'menutopbutwindows', className: 'button-style windows-setup' },
        { label: 'SCS Alarm', id: 'menutopbutscs', className: 'button-style scs-alarm' }
    ];

    useEffect(() => {
        const intervalId = setInterval(() => {
            let ActiveEvents = window.Base.Events.GetActiveEvents().CentumVP.AL.Messages;
            setData(ActiveEvents);
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    const arrow = `<div class="green-arrow"></div>`;
    const [previousItem, setPreviousItem] = React.useState<number | null>(null);
    const [selectedItem, setSelectedItem] = React.useState<number | null>(null);

    function SelectedRow(index: any) {
        setSelectedItem(index.indexNumber);
        window.OpenFaceplate(index.folder);
    }

    React.useEffect(() => {
        let TempData = [...data];

        if (previousItem !== null) {
            TempData[previousItem].selected = '';
        }

        if (selectedItem !== null) {
            TempData[selectedItem - 1].selected = arrow;
            setPreviousItem(selectedItem - 1);
        }

        setData(TempData);
    }, [selectedItem]);

    return (
        <div className={`alarm`} style={{ width: '100%', height: '100%' }}>
            <div className={`alarm__tab`} ref={tabAlarmRef}>
                {buttonData.map(({ label, id, className, onClick }) => (
                    <button
                        key={id}
                        id={id}
                        className={className}
                        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                            if (onClick) {
                                onClick(event);
                            }
                        }}></button>
                ))}
            </div>
            <div className={`alarm__table`} style={{ width: 'calc(100% - 12px)', height: 'calc(100% - 50px)' }}>
                <Table
                    header={[
                        {
                            type: 'element',
                            width: '30px',
                            label: '',
                            idCol: 'selected',
                            action: false
                        },
                        {
                            type: 'number',
                            width: '50px',
                            label: '',
                            idCol: 'indexNumber',
                            action: false
                        },
                        {
                            type: 'element',
                            width: '25px',
                            label: '',
                            idCol: 'alarm',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '60px',
                            label: '',
                            idCol: 'date',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '130px',
                            label: '',
                            idCol: 'time',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '150px',
                            label: '',
                            idCol: 'folder',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '350px',
                            label: '',
                            idCol: 'error',
                            action: false
                        },
                        {
                            type: 'text',
                            width: '100px',
                            label: '',
                            idCol: 'conditionName',
                            action: false
                        }
                    ]}
                    data={data}
                    // checked={checked}
                    // onCheck={SelectedRow}
                    VisibleDataRef={VisibleDataRef}
                    isFullRender={false}
                    onClickRow={SelectedRow}
                    width="100%"
                    height="100%"
                    paging={true}
                />
            </div>
        </div>
    );
}

export default ProcessAlarm;

export function createMenuButton(
    title: string,
    className: string,
    style: string,
    onClick?: () => void,
    onDoubleClick?: () => void
) {
    const button = document.createElement('input');
    button.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
    button.type = 'submit';
    button.value = ' ';
    button.title = title;
    button.setAttribute('class', className);
    button.style.cssText = style;

    return button;
}
